// import StoryblokClient from 'storyblok-js-client'

// class StoryblokService {
//   constructor() {
//     this.devMode = false
//     // TODO: add as .env variables
//     this.token = 'YDHb8JdTu9uA7mxKHmnLUgtt';
//     this.space = '111801';

//     this.client = new StoryblokClient({
//       accessToken: this.token,
//       space:'111801',
//       cache: {
//         clear: 'auto',
//         // type: 'memory'
//         type: 'none'
//       }
//     })
//     this.query = ''
//   }

//   getCacheVersion() {
//     return this.client.cacheVersion
//   }

//   get(slug, params) {
//     params = params || {}

//     if (this.getQuery('_storyblok') || this.devMode || (typeof window !== 'undefined' && window.storyblok)) {
//       params.version = 'draft'
//     }

//     if (typeof window !== 'undefined' && typeof window.StoryblokCacheVersion !== 'undefined') {
//       params.cv = window.StoryblokCacheVersion
//     }

//     return this.client.get(slug, params)
//   }

//   initEditor(story, setStory) {
//     if (window.storyblok) {
//       window.storyblok.init({
//         accessToken: this.token
//       })
//       window.storyblok.on(['change', 'published'], () => window.location.reload(true))

//       // this will alter the state and replaces the current story with a current raw story object (no resolved relations or links)
//       window.storyblok.on('input', (event) => {
//         if (event.story && event.story.content._uid === story.content._uid) {
//           event.story.content = window.storyblok.addComments(event.story.content, event.story.id)
//           window.storyblok.resolveRelations(event.story, ['featured-articles.articles'], () => {
//             setStory(event.story)
//           })
//         }
//       })
//     }
//   }

//   setQuery(query) {
//     this.query = query
//   }

//   getQuery(param) {
//     return this.query.includes(param)
//   }
// }

// const storyblokInstance = new StoryblokService()

// export default storyblokInstance

import { useEffect, useState } from 'react';
import StoryblokClient from 'storyblok-js-client';
// import config from '../../gatsby-config'
// const sbConfig = config.plugins.find((item) => item.resolve === 'gatsby-source-storyblok')

const Storyblok = new StoryblokClient({
  accessToken: 'YDHb8JdTu9uA7mxKHmnLUgtt',
  cache: {
    clear: 'auto',
    // type: "memory",
    type: 'none',
  },
});

export default function useStoryblok(originalStory, location) {
  let [story, setStory] = useState(originalStory);

  if (story && typeof story.content === 'string') {
    story.content = JSON.parse(story.content);
  }

  // see https://www.storyblok.com/docs/Guides/storyblok-latest-js
  function initEventListeners() {
    const { StoryblokBridge } = window;

    if (typeof StoryblokBridge !== 'undefined') {
      const storyblokInstance = new StoryblokBridge();

      storyblokInstance.on(['published', 'change'], (event) => {
        // reloade project on save an publish
        window.location.reload(true);
      });

      storyblokInstance.on(['input'], (event) => {
        // live updates when editing
        if (event.story._uid === story._uid) {
          setStory(event.story);
        }
      });

      storyblokInstance.on(['enterEditmode'], (event) => {
        // loading the draft version on initial view of the page
        Storyblok.get(`cdn/stories/${event.storyId}`, {
          version: 'draft',
          resolveRelations: ['Post.category', 'Post.topic', 'Post.postAuthor', 'Post.relatedPosts', 'download.category', 'download.topic', 'download.postAuthor', 'download.relatedPosts' ],
          resolveLinks: true,
        })
          .then(({ data }) => {
            if (data.story) {
              setStory(data.story);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    }
  }

  function addBridge(callback) {
    // check if the script is already present
    const existingScript = document.getElementById('storyblokBridge');
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = `//app.storyblok.com/f/storyblok-v2-latest.js`;
      script.id = 'storyblokBridge';
      document.body.appendChild(script);
      script.onload = () => {
        // call a function once the bridge is loaded
        callback();
      };
    } else {
      callback();
    }
  }

  useEffect(() => {
    // load bridge only inside the storyblok editor
    if (location && location.search.includes('_storyblok')) {
      // first load the bridge and then attach the events
      addBridge(initEventListeners);
    }
  }, []); // it's important to run the effect only once to avoid multiple event attachment

  return story;
}
